import { render } from "./WpeUrl.vue?vue&type=template&id=37f8ba48"
import script from "./WpeUrl.vue?vue&type=script&lang=js"
export * from "./WpeUrl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeUrl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37f8ba48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37f8ba48', __exports__)) {
    api.reload('37f8ba48', __exports__)
  }
  
  module.hot.accept("./WpeUrl.vue?vue&type=template&id=37f8ba48", () => {
    api.rerender('37f8ba48', render)
  })

}


export default __exports__